import { formatNotificationPrefill } from 'ck-utils';
import { useMemo } from 'react';
import { useNotificationsDraft } from './useNotificationsDraft';
import { useNotificationsHistory } from './useNotificationsHistory';
import { useNotificationsScheduled } from './useNotificationsScheduled';

export const useNotificationPrefill = (
  notificationId: string | undefined,
  isCopy: boolean
) => {
  const { data: historyNotifications, isLoading: isHistoryLoading } =
    useNotificationsHistory();
  const { data: draftNotifications, isLoading: isDraftLoading } =
    useNotificationsDraft();
  const { data: scheduledNotifications, isLoading: isScheduledLoading } =
    useNotificationsScheduled();

  const notifications = useMemo(
    () => [
      ...(historyNotifications ?? []),
      ...(draftNotifications ?? []),
      ...(scheduledNotifications ?? []),
    ],
    [historyNotifications, draftNotifications, scheduledNotifications]
  );

  if (!notificationId || notifications.length === 0) {
    return {
      data: undefined,
      isLoading: isHistoryLoading || isDraftLoading || isScheduledLoading,
    };
  }

  const maybeNotification = notifications.find(
    ({ id }) => id === notificationId
  );

  if (!maybeNotification) {
    return {
      data: undefined,
      isLoading: isHistoryLoading || isDraftLoading || isScheduledLoading,
    };
  }

  return {
    data: formatNotificationPrefill(maybeNotification, isCopy),
    isLoading: isHistoryLoading || isDraftLoading || isScheduledLoading,
  };
};
